
import {useEffect} from 'react';
import {absoluteUrl} from 'coreUtils/url';
import {useLocation} from 'coreHooks';
import {isServer} from 'coreUtils/utils';
import {CONVERSION_CHANNEL, CONVERSION_CHANNEL_STORAGE_KEY} from 'brandConstants';

export const useSubscribeSource = () => {
	const location = useLocation();

	useEffect(() => {
		const searchParamsURL = new URL(absoluteUrl(location.href));
		const searchParams = new URLSearchParams(searchParamsURL.search);
		const savedSource = !isServer ? !!localStorage.getItem(CONVERSION_CHANNEL_STORAGE_KEY) : null;
		let source;

		if (!savedSource) {
			Object.keys(CONVERSION_CHANNEL).forEach((fieldKey) => {
				const fieldValue = CONVERSION_CHANNEL[fieldKey];

				if (fieldKey === CONVERSION_CHANNEL.gclid || searchParams.get(fieldKey) === fieldValue) {
					source = fieldValue;
				}
			});

			if (source !== undefined) {
				localStorage.setItem(CONVERSION_CHANNEL_STORAGE_KEY, source);
			}
		}
	}, []);
};